


























import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Chrome } from 'vue-color';
import { namespace } from 'vuex-class';

const settings = namespace('Settings');

@Component({
  components: {
    'chrome-picker': Chrome,
  },
})
export default class Settings extends Vue {
  @settings.State public colorMode!: 'light' | 'dark';
  @settings.Mutation public setColorMode!: (mode: 'light' | 'dark') => void;
  @Prop() public state: boolean = false;

  public lightMode() {
    this.setColorMode('light');
  }

  public darkMode() {
    this.setColorMode('dark');
  }

  public closeSettings() {
    this.$emit('update:state', false);
  }
}
